<div class="modal-header">
    <h5 class="modal-title">Ölçüm Sonucu {{data ? 'Güncelle' : 'Ekle'}}</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body col-12">
    <form [formGroup]="measurementResult" (ngSubmit)="saveMeasurementResult()" enctype="multipart/form-data">

        <div class="card mb-50">
            <div class="card-header bg-light p-1" id="headingGeneral" (click)="isGeneralOpen = !isGeneralOpen">
                <h5 class="mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                    <span class="text-dark">
                        <i class="fa fa-info-circle mr-2"></i> 0. Genel Bilgiler (*)
                    </span>
                    <i class="fa"
                        [ngClass]="{'fa-chevron-down': isGeneralOpen, 'fa-chevron-right': !isGeneralOpen}"></i>
                </h5>
            </div>
            <div id="collapseGeneral" [ngbCollapse]="!isGeneralOpen">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-sm-12 form-group">
                            <label for="kindId" class="form-label">Tür (*)</label>
                            <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" placeholder="Seçiniz..."
                                formControlName="kindId" [searchable]="true" [clearable]="true">
                            </ng-select>
                        </div>

                        <div class="col-xl-6 col-md-6 col-sm-12 form-group">
                            <label for="referenceId" class="form-label">Referans</label>
                            <ng-select [items]="references" bindValue="id" placeholder="Seçiniz..."
                                formControlName="referenceId" [searchable]="true" [clearable]="true" #select>
                                <ng-template ng-header-tmp>
                                    <button
                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                        (click)="showCreateReferenceDialog(); select.blur(); select.close()">
                                        <i data-feather="plus"></i>
                                        <span class="align-middle ml-25">Referans Ekle</span>
                                    </button>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    {{ item.min }} {{ item.unitTypeName }} - {{ item.max }} {{ item.unitTypeName }}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.min }} {{ item.unitTypeName }} - {{ item.max }} {{ item.unitTypeName }}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-50">
            <div class="card-header bg-light p-1" id="headingCompany" (click)="isCompanyOpen = !isCompanyOpen">
                <h5 class="mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                    <span class="text-primary">
                        <i class="fa fa-building mr-2"></i> 1. Firma Bilgileri Konumu
                    </span>
                    <i class="fa"
                        [ngClass]="{'fa-chevron-down': isCompanyOpen, 'fa-chevron-right': !isCompanyOpen}"></i>
                </h5>
            </div>
            <div id="collapseCompany" [ngbCollapse]="!isCompanyOpen">
                <div class="card-body">
                    <h6 class="mt-1 text-primary border-bottom pb-1">Firma Adı (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="companyNameTargetSheetName"
                                placeholder="Firma Adı Sayfası" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="companyNameStartRow" placeholder="Satır No (Örn: 5)"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="companyNameStartColumn"
                                placeholder="Sütun No (Örn: 2)" class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-50" *ngIf="hasRowError('companyAdresTargetSheetName')">
                            Adres için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-primary border-bottom pb-1">Adres (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="companyAdresTargetSheetName" placeholder="Adres Sayfası"
                                class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="companyAdresStartRow" placeholder="Satır No (Örn: 6)"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="companyAdresStartColumn"
                                placeholder="Sütun No (Örn: 2)" class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-50" *ngIf="hasRowError('companyAdresTargetSheetName')">
                            Adres için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-50">
            <div class="card-header bg-light p-1" id="headingDevice" (click)="isDeviceOpen = !isDeviceOpen">
                <h5 class="mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                    <span class="text-danger">
                        <i class="fa fa-wrench mr-2"></i> 2. Cihaz Bilgileri Konumu
                    </span>
                    <i class="fa" [ngClass]="{'fa-chevron-down': isDeviceOpen, 'fa-chevron-right': !isDeviceOpen}"></i>
                </h5>
            </div>
            <div id="collapseDevice" [ngbCollapse]="!isDeviceOpen">
                <div class="card-body">
                    <h6 class="mt-2 text-danger border-bottom pb-1">Cihaz Adı (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="deviceNameTargetSheetName" placeholder="Sayfa Adı"
                                class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="deviceNameStartRow" placeholder="Satır No (Örn: 10)"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="deviceNameStartColumn" placeholder="Sütun No (Örn: 2)"
                                class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('deviceNameTargetSheetName')">
                            Cihaz Adı için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>

                    </div>

                    <h6 class="mt-1 text-danger border-bottom pb-1">Seri No</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="seriNoTargetSheetName" placeholder="Seri No Sayfası"
                                class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="seriNoStartRow" placeholder="Satır No"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="seriNoStartColumn" placeholder="Sütun No"
                                class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('seriNoTargetSheetName')">
                            Seri No için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>

                    </div>

                    <h6 class="mt-1 text-danger border-bottom pb-1">Çözünürlük</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="resolutionTargetSheetName"
                                placeholder="Çözünürlük Sayfası" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="resolutionStartRow" placeholder="Satır No"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="resolutionStartColumn" placeholder="Sütun No"
                                class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('resolutionTargetSheetName')">
                            Çözünürlük için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-danger border-bottom pb-1">Envanter No</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="inventoryNumberTargetSheetName"
                                placeholder="Envanter No Sayfası" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="inventoryNumberStartRow" placeholder="Satır No"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="inventoryNumberStartColumn" placeholder="Sütun No"
                                class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('inventoryNumberTargetSheetName')">
                            Envanter No için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-danger border-bottom pb-1">Tür Adı</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="kindNameTargetSheetName" placeholder="Tür Adı Sayfası"
                                class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Satırı</label>
                            <input type="number" formControlName="kindNameStartRow" placeholder="Satır No"
                                class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Başlangıç Sütunu</label>
                            <input type="number" formControlName="kindNameStartColumn" placeholder="Sütun No"
                                class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('kindNameTargetSheetName')">
                            Tür için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-2">
            <div class="card-header bg-light p-1" id="headingReferenceList"
                (click)="isReferenceListOpen = !isReferenceListOpen">
                <h5 class="mb-0 d-flex justify-content-between align-items-center cursor-pointer">
                    <span class="text-success">
                        <i class="fa fa-list mr-2"></i> 3. Referans Cihazlar Listesi Konumu
                    </span>
                    <i class="fa ml-1"
                        [ngClass]="{'fa-chevron-down': isReferenceListOpen, 'fa-chevron-right': !isReferenceListOpen}"></i>
                </h5>
            </div>
            <div id="collapseReferenceList" [ngbCollapse]="!isReferenceListOpen">
                <div class="card-body">
                    <p class="text-muted">Referans cihaz listesinin her bir kolonunun (*Veri Başlangıç Satırından
                        itibaren*) Excel'de nerede başladığını belirtiniz.</p>

                    <h6 class="mt-1 text-success border-bottom pb-1">Cihaz Adı Kolonu Bilgileri (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="referenceDeviceNameTargetSheetName"
                                placeholder="Aktarılacağı sayfa (sheet)" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Veri Başlangıç Satırı</label>
                            <input type="number" formControlName="referenceDeviceNameStartRow"
                                placeholder="Liste veri başlangıç satırı" class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Sütun</label>
                            <input type="number" formControlName="referenceDeviceNameStartColumn"
                                placeholder="Cihaz Adı Sütunu" class="form-control" min="1">
                        </div>

                        <div class="text-danger mt-1" *ngIf="hasRowError('referenceDeviceNameTargetSheetName')">
                            Cihaz adı için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-success border-bottom pb-1">Seri No Kolonu Bilgileri (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="referenceDeviceSeriNoTargetSheetName"
                                placeholder="Aktarılacağı sayfa (sheet)" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Veri Başlangıç Satırı</label>
                            <input type="number" formControlName="referenceDeviceSeriNoStartRow"
                                placeholder="Liste veri başlangıç satırı" class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Sütun</label>
                            <input type="number" formControlName="referenceDeviceSeriNoStartColumn"
                                placeholder="Seri No Sütunu" class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('referenceDeviceSeriNoTargetSheetName')">
                            Seri No için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-success border-bottom pb-1">Kabul Kriteri Kolonu Bilgileri (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="referenceDeviceAcceptanceTargetSheetName"
                                placeholder="Aktarılacağı sayfa (sheet)" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Veri Başlangıç Satırı</label>
                            <input type="number" formControlName="referenceDeviceAcceptanceStartRow"
                                placeholder="Liste veri başlangıç satırı" class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Sütun</label>
                            <input type="number" formControlName="referenceDeviceAcceptanceStartColumn"
                                placeholder="Kabul Kriteri Sütunu" class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('referenceDeviceAcceptanceTargetSheetName')">
                            Kabul Kriteri için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>

                    <h6 class="mt-1 text-success border-bottom pb-1">Belirsizlik Kolonu Bilgileri (*)</h6>
                    <div class="row">
                        <div class="form-group col-xl-6 col-md-6 col-sm-12">
                            <label>Sayfa Adı</label>
                            <input type="text" formControlName="referenceDeviceUncertaintyTargetSheetName"
                                placeholder="Aktarılacağı sayfa (sheet)" class="form-control">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Veri Başlangıç Satırı</label>
                            <input type="number" formControlName="referenceDeviceUncertaintyStartRow"
                                placeholder="Liste veri başlangıç satırı" class="form-control" min="1">
                        </div>
                        <div class="form-group col-xl-3 col-md-3 col-sm-6">
                            <label>Sütun</label>
                            <input type="number" formControlName="referenceDeviceUncertaintyStartColumn"
                                placeholder="Belirsizlik Sütunu" class="form-control" min="1">
                        </div>
                        <div class="text-danger mt-1" *ngIf="hasRowError('referenceDeviceUncertaintyTargetSheetName')">
                            Belirsizlik için Sayfa Adı, Başlangıç Satırı ve Sütun birlikte doldurulmalıdır.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-1 mb-3" />

        <div class="form-group mt-1">
            <label for="customFile">Dosya Seç</label>
            <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)" />
                <label class="custom-file-label" for="customFile">
                    {{ getSelectedFileName() }}
                </label>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">İptal</button>
            <button type="submit" class="btn btn-primary ml-2" [disabled]="measurementResult.invalid || isSubmitting">
                {{ isSubmitting ? 'Kaydediliyor...' : 'Kaydet' }}
            </button>
        </div>

    </form>
</div>